import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  OnDestroy,
  Output,
  EventEmitter,
  AfterViewInit,
  Input,
  ErrorHandler,
  AfterContentChecked
} from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs/Subject'
import {
  BsModalService,
  ModalBackdropComponent,
  ModalOptions,
  ModalBackdropOptions
} from 'ngx-bootstrap/modal'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import 'rxjs/add/operator/map'
import { debug } from 'util'
import { AuthorizeService } from '../../service/authorize.service'

@Component({
  selector: 'app-trading-compare-to-peer',
  templateUrl: './trading-compare-to-peer.component.html',
  styleUrls: ['./trading-compare-to-peer.component.scss']
})
export class TradingCompareToPeerComponent
  implements OnInit, OnDestroy, AfterViewInit, AfterContentChecked {
  @Input() isFullFactSheet: Boolean = false
  @Input() printPage
  @ViewChild(DataTableDirective) dtElement: DataTableDirective
  @ViewChild('template') template: TemplateRef<any>
  @Output() rTrading = new EventEmitter()
  modalRef: BsModalRef
  dtTrigger: Subject<any> = new Subject()
  subscription: Subscription
  subscriptionSearch: Subscription
  form: FormGroup
  TradingCompareToPeerDataTableOptions: DataTables.Settings = {}
  tradingCompareFullFactSheet: DataTables.Settings = {}
  dataTrading = {
    symbol: '',
    period: '',
    radio: '',
    securityIdPsims: ''
  }

  sortMockup: Array<Object> = []
  headerTable: Array<Object> = []
  symbol = ''
  period
  radioTrading

  radios = [
    { value: 'all', des: 'All' },
    { value: 'port', des: 'Selected by AE' }
  ]
  viewValue = 'port'

  tradingDataset: Array<Object> = []

  asc = 1
  desc = -1
  isAE

  securityIdPsims
  constructor(
    private modalService: BsModalService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private store: StoreService,
    private authorization: AuthorizeService,
    private modalOption: ModalOptions
  ) { }

  ngAfterContentChecked() {
    const x = document.getElementsByClassName('dataTables_scrollBody');
    if (x[0]) {
      if (x[0].scrollHeight > x[0].clientHeight) {
        document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add('scrollHeadInner')
      } else {
        document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add('noScrollHeadInner')
      }
    }
  }

  ngOnInit() {
    this.headerTable = [
      'No.',
      'Symbol',
      'Sector/Market',
      'Price (Baht)',
      'Avg trade (M.shares)',
      'Avg trade (M.Baht)',
      'Market cap (M.Baht)',
      'Turnover ratio (%)',
      'P/E'
    ]

    const { type } = this.activatedRoute.snapshot.params
    // type === undefined ? (this.viewValue = 'port') : (this.viewValue = type)
    this.form = new FormGroup({
      radioValue: new FormControl(this.viewValue)
    })
    if (type !== undefined && type !== null) {
      this.viewValue = type
      this.form.get('radioValue').setValue(type)
    } else {
      this.form.get('radioValue').setValue(this.viewValue)
    }
    this.TradingCompareToPeerDataTableOptions = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      scrollY: '500px',
      scrollCollapse: true,
      language: {
        emptyTable: 'No information found'
      },
      columnDefs: [
        {
          targets: 0,
          orderable: false
        }
      ],
      destroy: true
    }
    this.tradingCompareFullFactSheet = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      scrollX: true,
      ordering: false,
      destroy: true,
      language: {
        emptyTable: 'No information found'
      }
    }
    const { symbol, period } = this.activatedRoute.snapshot.params
    if (!!symbol) {
      this.symbol = symbol
    }


    this.subscription = this.store
      .getPeriodInputObservable()
      .subscribe(periodObj => {
        this.period = periodObj
        // console.log(!!periodObj, '---', !!this.symbol);
        if (periodObj.length > 0 && this.symbol.length > 0) {
          if (period !== undefined && period !== null) {
            this.period = period
          }
          if (type !== undefined && type !== null) {
            this.viewValue = type
            this.form.get('radioValue').setValue(type)
          }
          this.getInformation(this.symbol, this.period)
          this.cpmService.getIsAE(this.symbol).then(ae => {
            this.isAE = ae
          })
        }
      })

    this.subscriptionSearch = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.symbol = response['securitySymbol']
        if (period !== undefined && period !== null) {
          this.period = period
        }
        if (type !== undefined && type !== null) {
          this.viewValue = type
        }
        this.form.get('radioValue').setValue('port')
        this.getInformation(this.symbol, this.period)
        this.isAE = response['ae']
      })
  }

  get isUserHasPermission(): Boolean {
    return (
      this.authorization.hasRole('COMPINFO_EDIT')
    )
  }

  async getInformation(symbol, period) {
    this.symbol = symbol
    this.period = this.isFullFactSheet ? 'YTD' : period
    await this.getDatasetFromApi()
    if (this.tradingDataset.length < 1) {
      this.form.get('radioValue').setValue('all')
      await this.getDatasetFromApi()
    }
    this.rTrading.emit(this.form.get('radioValue').value)
    this.drawDataTable()
  }

  async onChangeTradingCompareByPeer() {
    this.rTrading.emit(this.form.get('radioValue').value)
    await this.getDatasetFromApi()
    this.drawDataTable()
  }

  async getDatasetFromApi() {
    await this.cpmService
      .getSecurityTradingByPeer(
        this.symbol,
        this.period,
        this.form.get('radioValue').value
      )
      .then(
        response => {
          this.tradingDataset = response
        },
        error => { }
      )
  }

  rerenderDatatable(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy()
      this.dtTrigger.next()
    })
  }

  drawDataTable() {
    this.rerenderDatatable()
    this.sortMockup = []
    this.tradingDataset.map(obj => {
      const data = obj
      data['bgColor'] = obj['securitySymbol'] === this.symbol ? 'hilight' : ''
      if (obj['securitySymbol'] === this.symbol) {
        this.securityIdPsims = obj['securityIdPsims']
      }
      this.sortMockup.push(data)
    })
    this.dataTrading['symbol'] = this.symbol
    this.dataTrading['period'] = this.period
    this.dataTrading['radio'] = this.form.get('radioValue').value
    this.dataTrading['securityIdPsims'] = this.securityIdPsims

    if (this.isFullFactSheet) {
      this.sortMockup = this.sortList(this.sortMockup, 'marketCap', this.desc)
      if (this.viewValue !== 'port') {
        let count
        let sortSymbol
        this.sortMockup.map((sortL, i) => {
          if (sortL['securitySymbol'] === this.symbol) {
            count = i
            sortSymbol = sortL
          }
        })
        if (count > 9) {
          this.sortMockup.map((sortL, i) => {
            const num = i + 1
            sortL['num'] = num
            this.sortMockup = this.sortMockup.slice(0, 9)
            this.sortMockup.push(sortSymbol)
          })
        } else if (count <= 9) {
          this.sortMockup.map((sortL, i) => {
            const num = i + 1
            sortL['num'] = num
            this.sortMockup = this.sortMockup.slice(0, 10)
          })
        }
      } else {
        this.sortMockup.map((sortL, i) => {
          const num = i + 1
          sortL['num'] = num
        })
      }
    } else {
      this.sortMockup = this.sortList(
        this.sortMockup,
        'securitySymbol',
        this.asc
      )
      this.sortMockup.map((sortL, i) => {
        const num = i + 1
        sortL['num'] = num
      })
    }
  }

  sortList(list, key, sort) {
    list.sort((obj1, obj2) => {
      if (obj1[key] > obj2[key]) {
        return 1 * sort
      }
      if (obj1[key] < obj2[key]) {
        return -1 * sort
      }
      return 0
    })

    return list
  }

  onClickOpenModal() {
    this.openModal(this.template)
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg', ignoreBackdropClick: true })
    )
  }

  closeModal() {
    this.modalRef.hide()
  }

  closeModalAndeRefaces(event) {
    this.form.get('radioValue').setValue('port')
    this.getInformation(event['symbol'], event['period'])
    this.modalRef.hide()
  }

  isClassLabel(id) {
    return id < 10
  }

  changedEvent(event) {
    $(event.target)
      .parents()
      .next('.hide')
      .toggle()
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next()
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
    this.subscriptionSearch.unsubscribe()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/trading-compare-to-peer/trading-compare-to-peer.component.ts